import { registerModal } from 'features/Modal/ModalRegistry'
import { showModal } from 'features/Modal/Modal.actions'
import PayWithCreditCardFormModal from './PayWithCreditCardFormModal'

export const modalType = 'PAY_WITH_CREDIT_CARD'
registerModal(modalType, PayWithCreditCardFormModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/PayWithCreditCardFormModal/PayWithCreditCardFormModal.action.js